import { createContext, useRef } from "react";
import { useHistory, useLocation, matchPath } from "react-router-dom";

export const VodBackgroundContext = createContext(false);
export const VOD_DETAIL_PATH = "/dashboard/voddetail/:vodId";
export const VOD_HOME = "/dashboard/home/home/all";
const isDetail = (location) =>
  !!matchPath(location.pathname, { path: VOD_DETAIL_PATH, exact: true });

export function openVodDetail(history, id, search = "") {
  const destination = `/dashboard/voddetail/${id}${search}`;
  // Related titles share one overlay history entry. Closing returns to the shelf.
  if (isDetail(history.location)) history.replace(destination);
  else history.push(destination);
}

export function useVodModalRoute() {
  const location = useLocation();
  const history = useHistory();
  const previousPage = useRef(null);
  const session = useRef(null);
  const open = isDetail(location);
  // HashRouter does not support location.state. Retain the actual page location
  // in memory instead, including its query, so its component stays mounted.
  if (open && !session.current) {
    session.current = {
      background: previousPage.current || {
        pathname: VOD_HOME,
        search: "",
        hash: ""
      },
      canGoBack: !!previousPage.current
    };
  } else if (!open) {
    previousPage.current = location;
    session.current = null;
  }
  const background = open ? session.current.background : location;
  const close = () => {
    if (session.current && session.current.canGoBack) history.goBack();
    else history.replace(VOD_HOME);
  };
  return {
    open,
    location,
    background,
    hasBackground: open && session.current.canGoBack,
    close
  };
}
